export const getRouteParam = (id) => {
  const queryParams = new URLSearchParams(window.location.search)
  const param = queryParams.get(id)
  return param
}
